<form [formGroup]="formGroup">
    <div class="contact-information-form m-t-10">
        <div class="contact-information-form-chip">
            <mat-chip-set cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="drop($event)">
                <div class="contact-information-form-chip-wrapper w-per-100" formArrayName="contactTypesRows">
                    @for (contact of contactTypesRows.controls; track contact; let idx = $index) {
                    <mat-chip color="primary" cdkDrag [formGroupName]="idx">
                        <div class="contact-information-form-chip-wrapper-container">
                            <!-- USER CONTACT ORDER -->
                            <div class="contact-information-form-chip-wrapper-order">
                                {{ contact?.get("order")?.value  + 1 }}
                            </div>

                            <!-- USER CONTACT TYPE -->
                            <div class="contact-information-form-chip-wrapper-type w-per-30">
                                <mat-form-field class="input-regular w-per-100" appearance="outline">
                                    <mat-label>{{ "configuration-page.action-dialog.contact-type" | translate
                                        }}</mat-label>
                                    <div matSuffix style="padding-left: 20px;">
                                        <fa-icon [icon]="['fal','angle-down']"
                                            [rotate]="contactTypeSelected?.panelOpen ? 180 : undefined"
                                            class="font-16 chevron-icon"></fa-icon>
                                    </div>
                                    <mat-select formControlName="contactType" multiple matNativeControl
                                        panelClass="panel-multi-select" id="contactType" #contactTypeSelected>
                                        @for (contactType of contactTypes; track contactType) {
                                        <mat-option class="panel-mat-option" [value]="contactType.contactTypeId"
                                            [id]="contactType.contactTypeId"
                                            (click)="propagateCheck(contactType.contactTypeId, idx, 'contactType')">
                                            <mat-checkbox [color]="'primary'" [id]="contactType.contactTypeId"
                                                [value]="contactType.contactTypeId"
                                                [checked]="isChecked(contactType.contactTypeId, idx, 'contactType')">
                                                {{ contactType.description }}
                                            </mat-checkbox>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- USER CONTACT TYPE VALUE-->
                            <div class="contact-information-form-chip-wrapper-value w-per-47">
                                <mat-form-field class="input-regular w-per-100" appearance="outline">
                                    <mat-label>{{ 'configuration-page.action-dialog.value' | translate }}</mat-label>
                                    <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput(idx, 'value')"
                                        [ngClass]="{'icon' : getValueInFormControl(idx, 'value'),
                                        'd-none': !getValueInFormControl(idx, 'value')}">
                                    </fa-icon>

                                    <input type="text" matInput formControlName="value" id="input-contact-type-value"
                                    (keydown)="clearInputByKey($event, idx, 'value')">
                                </mat-form-field>
                            </div>

                            <!-- USER ACTIVE STATE-->
                            <div class="contact-information-form-chip-wrapper-active">
                                <input type="checkbox" formControlName="active" [id]="'activeCheckbox_' + idx">
                                <label [for]="'activeCheckbox_' + idx" class="active-checkbox-label">
                                    {{'configuration-page.action-dialog.active' | translate }}
                                </label>
                            </div>
                        </div>
                    </mat-chip>
                    }
                </div>

            </mat-chip-set>
        </div>


        <div class="contact-information-form-actions">
            <button class="contact-information-form-actions-link link" (click)="addContactTypeRow()">
                <fa-icon class="font-12" [icon]="['fal', 'plus']"></fa-icon>
                <span class="font-12"> {{'configuration-page.action-dialog.new-contact-type' | translate }}</span>
            </button>
        </div>
    </div>

</form>
